import React from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { useActivitiesQuery } from "API";

import useFilterParam from "./useFilterParam";

const Activities: React.FC = () => {
  const { translate } = useTranslate();
  const title = translate("activity", { count: 1 });

  const { data = [], isSuccess, isError } = useActivitiesQuery();
  const [selected, setSelected] = useFilterParam("activity", data, {
    defaultToFirst: false,
    multi: true,
    ready: isSuccess || isError,
  });
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={title}
      selected={!!selected.length}
      count={selected.length ? selected.length : void 0}
      onChange={setSelected}
      disabled={!data.length || !selected}
      value={selected}
      multi={true}
      showReset={true}
      showApply={true}
      searchable={true}
      translate={translate}
    />
  );
};

export default Activities;
